import angular from 'angular';

module.exports = angular.module('common.services', [
  require('./accounting-buckets-by-kind'),
  require('./address-client'),
  require('./analytics'),
  require('./auth-handler'),
  require('./autocomplete-to-address'),
  require('./dropdown_label'),
  require('./flip-dates'),
  require('./formatted-cursor-position'),
  require('./hoa-frequencies'),
  require('./inspector_role_to_document_type'),
  require('./media-query'),
  require('./paginate'),
  require('./renovation_service_account_types'),
  require('./resource'),
  require('./resource-inheritable'),
  require('./subtotal'),
  require('./third-party-library-integrations'),
  require('./segment'),
  require('./timeout'),
  require('./times'),
  require('./weekday-work-calendar'),
  require('./work-calendar'),
  require('./work-order-starting'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/index.js
 **/